import { EHomeSearchWidgetVariant, HomeSearchWidget } from '@/components/ui/HomeSearchWidget';

interface ISearchWidget {
  className?: string;
  variant: EHomeSearchWidgetVariant;
}

export const SearchWidget = ({ className, variant }: ISearchWidget) => {
  return (
    <div className={className}>
      <HomeSearchWidget variant={variant} />
    </div>
  );
};
